exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoped-unset-pointer-events[data-v-7ba5bd90]{pointer-events:none}.scoped-new-questioneditor[data-v-7ba5bd90]{min-height:75vh}.loading-back-greyed[data-v-7ba5bd90]{background-color:hsla(0,0%,78.4%,.4);width:100%;height:100%;min-height:60vh}.scoped-contain-slider[data-v-7ba5bd90]{min-height:200px;position:relative}.scoped-small-border[data-v-7ba5bd90]{border:1px solid hsla(0,0%,72.2%,.8);padding:.6rem 1rem;border-radius:4px}", ""]);

// exports
